<div class="c-checkbox">
  <input
    type="checkbox"
    [id]="name"
    [name]="name"
    [checked]="checked"
    [disabled]="disabled"
    (change)="onChecked($event)"
  />
  <label
    [for]="name"
    class="c-checkbox-md"
    [ngClass]="{
      'c-text-gray': disabled,
      disabled: disabled
    }"
    >{{ name }}</label
  >
</div>
